// extracted by mini-css-extract-plugin
export var navSocial = "social-module--navSocial--Q3quq";
export var tooltiptext = "social-module--tooltiptext--PRXzE";